import { crudActions } from "./CrudActions"

export default {
  ...crudActions("nombre-participants"),
}
